import "./progress-circle.css";
import { ProgressCircle } from './progress-circle';
export default ProgressCircle;